import { ComponentFactoryResolver, ComponentRef, Injectable, ViewContainerRef } from "@angular/core";
import {
  AddNewSectionComponent,
  AppointmentFormComponent,
  AuthenticateUserComponent,
  AuthenticationRequiredComponent,
  BannerCarouselComponent,
  BannerGridSectionComponent,
  BannerSectionComponent,
  BlogListComponent,
  BookAppointmentComponent,
  CarouselBannerComponent,
  CartComponent,
  CategoryProductComponent,
  CheckoutComponent,
  ChooseUsSectionComponent,
  ContactUsComponent,
  CustomerReviewComponent,
  EnrollmentFormComponent,
  FaqSectionComponent,
  FeaturedCategoryComponent,
  FeaturedCollectionComponent,
  FeaturedProductsComponent,
  FeaturesSectionComponent,
  FooterComponent,
  HeaderSectionComponent,
  HeaderTextComponent,
  ImageCarouselSectionComponent,
  ImageGridSectionComponent,
  ImageSectionComponent,
  LocationSectionComponent,
  LogoGalleryComponent,
  LogoShowcaseComponent,
  NewCollectionComponent,
  NewServicesComponent,
  NewsLetterComponentComponent,
  NewTestimonialsComponent,
  PricingSectionComponent,
  ProcessModernComponent,
  ProcessSectionComponent,
  ProductCategoryListComponent,
  ProductDescComponent,
  ProductListComponent,
  RecentBlogPostSectionComponent,
  RegistrationFormComponent,
  ReturnsCalculatorComponent,
  SchemeDetailComponent,
  SchemesComponent,
  ServiceSectionComponent,
  SkeletonLoaderSectionComponent,
  StoreListComponent,
  StorePageComponent,
  TeamMemberSectionComponent,
  TestimonialFullwidthComponent,
  TestimonialSectionComponent,
  TestimonialVideoComponent,
  TextImageSectionComponent,
  TextSectionComponent,
  UserProfileComponent,
  VerifyComponent,
  VideoSectionComponent,
  ViewBlogComponent,
  WhislistComponent,
  AppointmentBookingComponent,
  ImageGridHotspotComponent,
  VideoGridSectionComponent,
  ReferEarnComponent,
  CondensedAndGradientComponent,
  FourFeaturesCenteredImageComponent,
  OverlappingImageComponent,
  ImageBackgroundComponent,
  ButtonGridSectionComponent,
  ProductInfoSectionComponent,
  FaqColumnsCardsComponent,
  VideoCarouselSectionComponent,
  FeatureExperienceSectionComponent,
  TestimonialSliderComponent,
  BrandStorySectionComponent,
  CountdownBannerComponent,
  MovingTextComponent
} from 'simpo-component-library';
import { TemplateService } from "./template.service";
import { lastValueFrom } from "rxjs";
import { EventEmmiterService } from "./event-emmiter.service";

@Injectable({
  providedIn: 'root'
})

export class DynamicSectionService {
  componentsReferences = Array<ComponentRef<any>>()

  constructor(
    private comFactoryResolver: ComponentFactoryResolver,
    private templateService: TemplateService,
    private eventService: EventEmmiterService
  ) { }

  componentList: any = [
    {
      sectionType: 'countdownbanner',
      component: CountdownBannerComponent
    },
    {
      sectionType: 'movingtext',
      component: MovingTextComponent
    },
    {
      sectionType: "referearn",
      component: ReferEarnComponent
    },
    {
      sectionType: 'banner',
      component: BannerSectionComponent
    },
    {
      sectionType: 'text',
      component: TextSectionComponent
    },
    {
      sectionType: 'image',
      component: ImageSectionComponent
    },
    {
      sectionType: 'text_image',
      component: TextImageSectionComponent
    },
    {
      sectionType: 'service',
      component: ServiceSectionComponent
    },
    {
      sectionType: 'testimonial',
      component: TestimonialSectionComponent
    },
    {
      sectionType: 'imagegrid',
      component: ImageGridSectionComponent
    },
    {
      sectionType: 'imageCarousel',
      component: ImageCarouselSectionComponent
    },
    {
      sectionType: 'video',
      component: VideoSectionComponent
    },
    {
      sectionType: 'videogrid',
      component: VideoGridSectionComponent
    },
    {
      sectionType: 'faqcolumnscards',
      component: FaqColumnsCardsComponent
    },
    {
      sectionType: 'buttongridsection',
      component: ButtonGridSectionComponent
    },
    {
      sectionType: 'productinfosection',
      component: ProductInfoSectionComponent
    },
    {
      sectionType: 'teammember',
      component: TeamMemberSectionComponent
    },
    {
      sectionType: "header",
      component: HeaderSectionComponent
    },
    {
      sectionType: "footer",
      component: FooterComponent
    },
    {
      sectionType: 'condensedandgradient',
      component: CondensedAndGradientComponent
    },
    {
      sectionType: 'fourfeaturesimage',
      component: FourFeaturesCenteredImageComponent
    },
    {
      sectionType: 'overlappingimage',
      component: OverlappingImageComponent
    },
    {
      sectionType: 'imagebackground',
      component: ImageBackgroundComponent
    },
    {
      sectionType: "addNewSection",
      component: AddNewSectionComponent
    },
    {
      sectionType: "contact us",
      component: ContactUsComponent
    },
    {
      sectionType: "section-loader",
      component: SkeletonLoaderSectionComponent
    },
    {
      sectionType: "faq",
      component: FaqSectionComponent
    },
    {
      sectionType: "bannerGrid",
      component: BannerGridSectionComponent
    },
    {
      sectionType: "chooseUs",
      component: ChooseUsSectionComponent
    },
    {
      sectionType: "pricing",
      component: PricingSectionComponent
    },
    {
      sectionType: "headerText",
      component: HeaderTextComponent
    },
    {
      sectionType: 'location',
      component: LocationSectionComponent
    },
    {
      sectionType: 'blogPost',
      component: RecentBlogPostSectionComponent
    },
    {
      sectionType: 'blogList',
      component: BlogListComponent
    },
    {
      sectionType: 'viewBlog',
      component: ViewBlogComponent
    },
    {
      sectionType: 'process',
      component: ProcessSectionComponent
    },
    {
      sectionType: 'processModern',
      component: ProcessModernComponent
    },
    {
      sectionType: 'feature',
      component: FeaturesSectionComponent
    },
    {
      sectionType: 'testimonialFullWidth',
      component: TestimonialFullwidthComponent
    },
    {
      sectionType: 'fourcoloumnwithcoloredicons',
      component: LogoShowcaseComponent
    },
    {
      sectionType: 'logoShowcase',
      component: LogoShowcaseComponent
    },
    {
      sectionType: 'featuredProduct',
      component: FeaturedProductsComponent
    },
    {
      sectionType: 'featuredcategory',
      component: FeaturedCategoryComponent
    },
    {
      sectionType: 'productList',
      component: ProductListComponent
    },
    {
      sectionType: 'productDescription',
      component: ProductDescComponent
    },
    {
      sectionType: 'cart',
      component: CartComponent
    },
    {
      sectionType: 'checkout',
      component: CheckoutComponent
    },
    {
      sectionType: 'wishlist',
      component: WhislistComponent
    },
    {
      sectionType: 'profile',
      component: UserProfileComponent
    },
    {
      sectionType: 'authenticate',
      component: AuthenticateUserComponent
    },
    {
      sectionType: 'verify-payment',
      component: VerifyComponent
    },
    {
      sectionType: 'carouselBanner',
      component: CarouselBannerComponent
    },
    {
      sectionType: 'bannerCarousel',
      component: BannerCarouselComponent
    },
    {
      sectionType: 'categoryProduct',
      component: CategoryProductComponent
    },
    {
      sectionType: 'productCategoryList',
      component: ProductCategoryListComponent
    },
    {
      sectionType: 'customerReview',
      component: CustomerReviewComponent
    },
    {
      sectionType: 'featuredCollection',
      component: FeaturedCollectionComponent
    },
    {
      sectionType: 'login',
      component: AuthenticationRequiredComponent
    },
    {
      sectionType: 'testimonialVideo',
      component: TestimonialVideoComponent
    },
    {
      sectionType: 'appointment',
      component: AppointmentFormComponent
    },
    {
      sectionType: 'registrationForm',
      component: RegistrationFormComponent
    },
    {
      sectionType: 'admissionForm',
      component: RegistrationFormComponent
    },
    {
      sectionType: 'logoGallery',
      component: LogoGalleryComponent
    },
    {
      sectionType: 'newFooter',
      component: FooterComponent

    },
    {
      sectionType: 'assistance',
      component: NewServicesComponent
    },
    {
      sectionType: 'recommendation',
      component: NewTestimonialsComponent
    },
    {
      sectionType: 'featuredCollectionV2',
      component: NewCollectionComponent
    },
    {
      sectionType: 'newsLetter',
      component: NewsLetterComponentComponent
    },
    {
      sectionType: 'storeList',
      component: StoreListComponent
    },
    {
      sectionType: 'storePage',
      component: StorePageComponent
    },
    {
      sectionType: 'appointmentBooking',
      component: BookAppointmentComponent
    },
    {
      sectionType: 'enrollmentForm',
      component: EnrollmentFormComponent
    },
    {
      sectionType: 'returnsCalculator',
      component: ReturnsCalculatorComponent
    },
    {
      sectionType: 'schemes',
      component: SchemesComponent
    },
    {
      sectionType: 'schemeDetail',
      component: SchemeDetailComponent
    },
    {
      sectionType: 'bookAppointment',
      component: AppointmentBookingComponent
    },
    {
      sectionType: 'imagegridhotspot',
      component: ImageGridHotspotComponent
    },
    {
      sectionType: 'featuredcategoryv2',
      component: FeaturedCategoryComponent
    },
    {
      sectionType: 'featuredproductv2',
      component: FeaturedProductsComponent
    },
    {
      sectionType: 'videocarousel',
      component: VideoCarouselSectionComponent
    },
    {
      sectionType: 'featureexperiencesection',
      component: FeatureExperienceSectionComponent
    },
    {
      sectionType: 'testimonialslider',
      component: TestimonialSliderComponent
    },
    {
      sectionType: 'brandStorysection',
      component: BrandStorySectionComponent
    },
  ];

  loadDynamicSection(displaySection: ViewContainerRef | any, sectionList: any[], edit, contentDelete: boolean = false, subIndustryId?: any) {
    this.componentsReferences = [];
    displaySection.clear()
    sectionList.forEach((section, index) => {
      this.componentList.forEach((component) => {
        if (component.sectionType === section.sectionType) {
          // if (section.type === 'E_COMMERCE') {
          //   this.getDummyData(subIndustryId, section.sectionType);
          // }
          const componentFactory = this.comFactoryResolver.resolveComponentFactory(component.component);
          const k = displaySection.createComponent(componentFactory);
          k.instance.data = section;
          k.instance.responseData = section.responseData;
          if (section.sectionType === 'header') {
            k.instance.nextComponent = sectionList[1];
          }
          k.instance.index = index;
          k.instance.edit = edit ?? false;
          // k.instance.delete = contentDelete;
          k.instance.nextComponentColor = sectionList[index + 1]?.styles?.background;
          this.componentsReferences.push(k);
        }
      })
    })

    return this.componentsReferences?.[0]?.instance?._eventService || null;
  }

  createDynamicComponents(displaySection: ViewContainerRef | any, sectionList: any[], edit, contentDelete?:any) {
    this.componentsReferences = [];
    displaySection?.clear()
    sectionList.forEach((section, index) => {
      this.componentList.forEach((component) => {
        if (component.sectionType === section.sectionType) {
          const componentFactory = this.comFactoryResolver.resolveComponentFactory(component.component);
          const k = displaySection.createComponent(componentFactory);
          if (section.sectionType === 'header') {
            k.instance.nextComponent = sectionList[1];
          }
          k.instance.index = index;
          k.instance.edit = edit;
          k.instance.delete = contentDelete;
          k.instance.nextComponentColor = sectionList[index + 1]?.styles?.background;
          this.componentsReferences.push(k);
        }
      })
    })

    return this.componentsReferences?.[0]?.instance?._eventService || null;
  }

  loadDynamicSectionv2(
    displaySection: ViewContainerRef | any,
    sectionList: any[],
    edit,
    contentDelete: boolean = false,
    subIndustryId?: any
  ) {
    this.componentsReferences = [];

    displaySection.clear();
    let componentFactoryList: any[] = [];

    const promises = sectionList.map(async (section, index) => {
      for (const component of this.componentList) {
        if (component.sectionType === section.sectionType) {
          let res;
          if (section.type === 'E_COMMERCE') {
            res = await this.getDummyData(subIndustryId, section.sectionType);
          }
          const componentFactory = this.comFactoryResolver.resolveComponentFactory(component.component);
          componentFactoryList.splice(index, 0, { component: componentFactory, res: res?.data, section: section })
          // const k = displaySection.createComponent(componentFactory);
          // k.instance.data = section;
          // k.instance.index = index;
          // k.instance.edit = edit;
          // k.instance.responseData = res?.data
          // k.instance.delete = contentDelete;
          // this.componentsReferences.push(k);
        }
      }
    });

    return Promise.all(promises).then(() => {

      componentFactoryList.forEach((factory, index) => {
        const k = displaySection.createComponent(factory.component);
        k.instance.data = factory.section;
        k.instance.index = index;
        k.instance.edit = edit;
        k.instance.responseData = factory.res
        k.instance.delete = contentDelete;
        k.instance.nextComponentColor = factory[index + 1]?.styles?.background;
        this.componentsReferences.push(k);
      })
      const eventService = this.componentsReferences?.[0]?.instance?._eventService || null;
      this.eventService.instanceEmitter.emit({ instance: eventService });
      return eventService;
    });
  }

  addSection(displaySection: ViewContainerRef | any, newComponment: any, edit: boolean, index: number, sectionType?: any) {
    let componentFact = this.componentList.forEach((listCompos, i) => {
      if (listCompos.sectionType === newComponment.sectionType) {
        const componentFactory = this.comFactoryResolver.resolveComponentFactory(listCompos.component);
        const k = displaySection.createComponent(componentFactory, index);
        k.instance.data = newComponment;

        if (sectionType) k.instance.sectionType = sectionType;

        k.instance.edit = edit;

        k.instance.canEditAll = true;
        k.instance.index = index;

        this.componentsReferences.splice(index, 0, k);

        for (let i = index + 10 + 1; i < displaySection._lContainer.length; i++) {
          if (displaySection._lContainer[i][8].index) {
            displaySection._lContainer[i][8].index = displaySection._lContainer[i][8].index + 1;
          }
        }

      }
    });
    return this.componentsReferences?.[0]?.instance?._eventService || null;
  }


  updateSection(displaySection, index: number, newData: any, edit: boolean, sectionType?: any, subIndustryId?: any) {
    const componentToRemove = displaySection.get(index);
    if (componentToRemove) {
      componentToRemove.destroy();
    }

    this.componentsReferences.splice(index, 1);
    this.componentList.forEach(async (listCompos, i) => {
      if (listCompos.sectionType === newData.sectionType) {
        let res;
        if (newData.type === 'E_COMMERCE') {
          res = await this.getDummyData(subIndustryId, newData.sectionType);
        }

        const componentFactory = this.comFactoryResolver.resolveComponentFactory(listCompos.component);
        const k = displaySection.createComponent(componentFactory, index);
        k.instance.data = newData;
        k.instance.edit = edit;
        k.instance.responseData = res?.data;
        if (index == 1) {
          displaySection._lContainer[10][8].nextComponent = newData
        }
        k.instance.nextComponentColor = displaySection._lContainer[11 + index][8]?.data?.styles?.background;
        if (displaySection._lContainer[10 + index - 1][8]?.nextComponentColor)
          displaySection._lContainer[10 + index - 1][8].nextComponentColor = newData.styles.background;
        k.instance.canEditAll = true;
        if (sectionType) k.instance.sectionType = sectionType;
        k.instance.index = index;
        this.componentsReferences.splice(index, 0, k);

      }
    });
    return this.componentsReferences?.[0]?.instance?._eventService || null;
  }

  async getDummyData(subIndustryId: any, sectionType: any) {
    if (sectionType === 'productList' || sectionType === 'featuredProduct') {
      try {
        const res = await lastValueFrom(this.templateService.getDummyProductList(subIndustryId));
        return res;
      } catch (error) { }
    }
    if (sectionType === 'featuredCategory') {
      try {
        const res = await lastValueFrom(this.templateService.getDummyCategory(subIndustryId));
        return res;
      } catch (error) { }
    }
    if (sectionType === 'productDescription') {
      try {
        const res = await lastValueFrom(this.templateService.getDummyProduct(subIndustryId));
        return res;
      } catch (error) { }

    }
    if (sectionType === 'cart') {
      try {
        const res = await lastValueFrom(this.templateService.getDummyProduct(subIndustryId));
        return res;
      } catch (error) { }
    }
    return null;
  }

  markSectionForCheck(sectionId: string): void {
    const ref = this.componentsReferences.find(r => r.instance?.data?.id === sectionId);
    ref?.changeDetectorRef.markForCheck();
  }
  

}
